// ./config/themes/games/crash/skyx.theme.ts
import { Theme } from '../../ITheme';
import crashTheme from '../../crash.theme';

const skyxTheme: Theme = {
  ...crashTheme, // inherit everything from crashTheme
  colors: {
    ...crashTheme.colors,
    background: '#0D1117',
    background2: '#5e6062ff',
    background3: '#1b1c1d',
    background4: '#bbc0c5ff',
    qbet: '#484b4cff',
    slider: '#353536ff',
    primary: '#FF4757',
    secondary: '#232628ff',

    // success: "#28A745",
    //  danger: "#e91328ff",
    //  warning: "#d07206",
    text: '#FFFFFF',
    overlay: 'rgba(0, 0, 0, 0.5)',
    border: '#FFFFFF33',
    betborder: '#b2f2a3',
    betbutton: '#28a909',
    autoplayBtBg: '#1D7ACA',
    autoplayBtBgborder: '#53b1cdff',
    autoplayBgHover: '#007bff',

    betHover: '#00c417ff',
    cancelborder: '#ff7171',
    cashoutborder: '#ffbd71',
    text2: '#ede7e7e0',
    // Custom colors for BetBox buttons in this theme
    // betIdle: "#22C55E",   // Green for placing a bet
    // betCancel: "#EF4444", // Red for cancelling
    // betCashout: "#F59E0B", // Orange for cashing out

    // 👇 Multiplier-specific tokens
    multiplierHigh: '#9333ea', // purple for ≥ 10x
    multiplierMedium: '#F59E0B', // amber for ≥ 5x
    multiplierLow: '#22C55E', // green for ≥ 2x
    multiplierBase: '#1cadda', // teal for < 2x
    msgBg: 'rgba(29, 45, 38, 0.9)',
    // autoplayBtBg: "#1cadda", // teal for autoplay button background
    // autoplayBgHover: "#398ba4ff" // lighter teal on hover
  },
  fonts: {
    ...crashTheme.fonts,
    primary: 'Orbitron, sans-serif',
    button: 'Orbitron, sans-serif',
  },
  uiElements: {
    ...crashTheme.uiElements,
    button: {
      ...crashTheme.uiElements.button,
      borderRadius: '8px',
      padding: '10px 18px',
      fontSize: '15px',
    },
    card: {
      ...crashTheme.uiElements.card,
      borderRadius: '12px',
      shadow: '0 4px 10px rgba(0,229,255,0.2)',
    },
    modal: {
      ...crashTheme.uiElements.modal,
      borderRadius: '16px',
      background: '#111827',
    },
  },
};

export default skyxTheme;
